<!-- eslint-disable-next-line @nx/workspace-mx-use-button-components -- This anchor wraps an entire dashboard stat card, not just text. -->
<a [pxNamedRouterLink]="targetRouteName" class="block w-full text-on-surface">
  <mat-card>
    <mat-card-title mxTruncate class="text-headline-small p-5 pb-0">
      {{ titleValue }}
    </mat-card-title>

    <mat-card-subtitle mxTruncate class="text-body-medium px-5 pb-3">
      @if (showSubtitle) {
        @if (subtitleLabel) {
          {{ subtitleLabel }}
        }

        {{ subtitleValue | format:subtitleValueFormat }}
      } @else {
        &nbsp; <!-- Reserve vertical space for the subtitle even if it's empty.  This keeps the card a consistent height either way. -->
      }
    </mat-card-subtitle>

    <mat-card-content class="text-display-small px-5 pt-0 pb-3">
      {{ value | format:valueFormat }}
    </mat-card-content>
  </mat-card>
</a>
